import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appGhostButtonWithBorder]',
    standalone: false
})
export class GhostButtonWithBorderDirective {
    @HostBinding('class') get classes(): string {
        return 'ghost-button-uniform ghost-button-uniform--with-border';
    }
}
